//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SectionWithFilter from '../../components/SectionWithFilter.vue'
import DispatcherVehiclesTab from '../../pages/main/sections/Dispatcher/DispatcherTab/DispatcherVehiclesTab.vue'

export default {
  name: 'OrganizationCardSectionProvidableVehicles',
  components: {
    SectionWithFilter,
    DispatcherVehiclesTab
  },
  props: {
    config: {
      type: Object,
      required: true
    },
    objectSrc: {
      type: Object,
      default: null
    }
  },
  data: () => {
    const formId = 'organizationProvidableVehicles'

    return {
      formId: formId,

      filterConfig: {
        filterName: 'ФИЛЬТР ТС',
        filterType: 'vehicle',
        filterFormId: formId,
        filterUnavailable: false
      }
    }
  },
  computed: {
    objectId: function () {
      return this.objectSrc && this.objectSrc.id || null
    }
  },
  watch: {
    objectSrc: {
      handler: function (object) {
        this.onObjectChanged(object)
      },
      immediate: true
    }
  },
  methods: {
    onObjectChanged: function (object) {
      const tabComponent = this.$refs.tabComponent
      if (tabComponent && tabComponent.onUpdate) {
        tabComponent.onUpdate()
      }
    }
  }
}
